import { useEffect, useRef } from 'react';

function useEffectAfterMount(effect, deps) {
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        return effect();
    }, deps);
}

export default useEffectAfterMount;
